import axios from 'axios'
import env from '../env'

export default class ThirdPartyApi {
  /** 获取三方券配置 */
  static getThirdCouponConfig = async () => {
    const Url: string = `${env.JMOBILE}/mobileHomePage/getThirdCouponConfig`
    return await axios.post(Url).catch((err) => {
      return err
    })
  }
}
